import EventActionProto from '../event-action-proto';
import CrmContactCollectionSession from "../../model2/crm/contact/session/collection-session";

export default class SessionCrmContact extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId);

        this.method = sessionEvent.method;
        this.fromSID = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false;

        switch (this.method) {
            case 'reset': gd.session._crmContacts = new CrmContactCollectionSession(this.data); break;
            default:
                this._updateSessionCollection();
                this._sendBusUpdate();
                break;
        }

        this._resetFieldOptions();
    }

    /**
     * The CRM contact fields build their options from the session collection once and cache them
     * (FieldCrmContact/FieldCrmContacts.getOptions), so a contact created, renamed or deleted
     * after that would never resolve: _getOption() finds nothing and the field renders as empty -
     * a new contact added to a task showed a blank row in the task view's CRM block.
     * Every change to the collection lands here, so this is where the cache is dropped.
     */
    _resetFieldOptions() {
        if (!gd.fields || !gd.fields.task) return;

        gd.fields.task.crmContactId._options    = null;
        gd.fields.task.crmContactIds._options   = null;
    }

    _updateSessionCollection() {
        // if user never initialized session.crmContacts we don't update it
        if (!gd.session.crmContacts) return false;

        gd.session.crmContacts.applyDelta(this.method, this.data);
    }

    _sendBusUpdate() {
        // send
        gd.modelBus.newUpdate('crm-contact', this.method, this.data.id, this.data);
    }
}
